function isObject(value) {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function http_build_query(obj, num_prefix, temp_key) {

  var output_string = []

  Object.keys(obj).forEach(function (val) {

    var key = val;

    num_prefix && !isNaN(key) ? key = num_prefix + key : ''

    var key = encodeURIComponent(key.replace(/[!'()*]/g, escape));
    temp_key ? key = temp_key + '[' + key + ']' : ''

    if (typeof obj[val] === 'object') {
      var query = http_build_query(obj[val], null, key)
      output_string.push(query)
    }

    else {
      var value = encodeURIComponent(obj[val].toString().replace(/[!'()*]/g, escape));
      output_string.push(key + '=' + value)
    }

  })

  return output_string.join('&')

}

function sanitise_params(params) {

  let newParams = JSON.parse(JSON.stringify(params));

  Object.keys(newParams).forEach(key => {
    if (Array.isArray(params[key])) { // THIS MUST BE FIRST, ARRAY IS AN OBJECT
      if (params[key].length < 1) {
        delete params[key];
      }
    }
    else if (isObject(params[key])) {
      sanitise_params(params[key]);
      if (Object.keys(params[key]) < 1) {
        delete params[key];
      }
    }
    else if (typeof params[key] === 'undefined') {
      delete params[key];
    }
    else if (params[key] === null) {
      delete params[key];
    }
    else if (typeof params[key] === 'string' && params[key].trim() === "") {
      delete params[key];
    }
  });

  return newParams;

}

// ChatGPT
function unwrap_label_value(obj) {
  if (Array.isArray(obj)) {
    // Process each element of the array recursively
    return obj.map(unwrap_label_value);
  }
  else if (isObject(obj)) {
    // Check if it's exactly a { label, value } pair
    const keys = Object.keys(obj);
    if (keys.includes('label') && keys.includes('value')) {
      return unwrap_label_value(obj.value); // replace entire object with its value
    }
    // if (keys.length === 2 && keys.includes('label') && keys.includes('value')) {
    //   return unwrap_label_value(obj.value); // replace entire object with its value
    // }
    // Otherwise, recurse through its properties
    const newObj = {};
    for (const key in obj) {
      newObj[key] = unwrap_label_value(obj[key]);
    }
    return newObj;
  }
  // Primitive value: return as-is
  return obj;
}

function array_to_object(obj) {
  if (Array.isArray(obj)) {
    // Convert array to object with index keys
    const newObj = {};
    obj.forEach((item, index) => {
      newObj[index] = array_to_object(item); // recurse into each element
    });
    return newObj;
  }
  else if (isObject(obj)) {
    // Recurse through object properties
    const newObj = {};
    for (const key in obj) {
      newObj[key] = array_to_object(obj[key]);
    }
    return newObj;
  }
  // Primitive value: return as-is
  return obj;
}

function extract_key_operator(str) {
  // Get the base field name before any '['
  const fieldMatch = str.match(/^([^\[\]]+)/);
  if (!fieldMatch) return null;

  const field = fieldMatch[1];
  const result = { field };

  // Get all bracket contents: e.g., [hello=1][compare==] -> "hello=1", "compare=="
  const bracketMatches = [...str.matchAll(/\[([^\[\]]+)\]/g)];

  for (const [, inner] of bracketMatches) {
    // Split only on the first '=' (some values might contain '=')
    const parts = inner.split('=');

    if (parts.length === 1) {
      // Just [flag] → { flag: true }
      result[inner] = true;
    }
    else {
      const key = parts[0];
      const rawValue = parts.slice(1).join('='); // recombine in case of multiple '='
      let value;

      // Special handling for [compare==] → compare: '='
      if (rawValue === '') {
        value = true;
      }
      else if (rawValue === '=') {
        value = '=';
      }
      else {
        // Try to coerce numeric values
        const num = Number(rawValue);
        value = isNaN(num) ? rawValue : num;
      }

      result[key] = value;
    }
  }

  return result;
}

// function extract_key_operator(str) {
//   const match = str.match(/^([^\[\]]+)(?:\[(.*?)\])?$/);
//   if (!match) return { field: null, compare: null };
//   const [, field, compare] = match;
//   return { field, compare: compare || "=" };
// }

function object_to_compare_object(obj) {
  const result = {};
  let index = 0;

  for (const key in obj) {
    const value = obj[key];

    // ✅ Handle logical relations ('and' / 'or')
    if (key === 'and' || key === 'or') {
      let nested = object_to_compare_object(value);
      // Start a new block for this relation
      // const relationBlock = {
      //   0: { key: 'relation', value: key.toUpperCase() },
      // };
      nested['relation'] = key.toUpperCase();
      result[index++] = nested;
      // Append nested entries sequentially
      // let nestedIndex = 1;
      // for (const subKey in nested) {
      //   relationBlock[nestedIndex++] = nested[subKey];
      // }
      // result[index++] = relationBlock;
    }

    else if (Array.isArray(value)) {
      // If value is an array, use compare = "IN"
      const { field, ...attrs } = extract_key_operator(key);
      result[index++] = {
        key: field,
        value,
        compare: "IN",
        ...attrs,
      };
    }

    else if (isObject(value)) {
      // If nested object, recurse
      const nested = object_to_compare_object(value);
      result[index++] = nested;
    }

    else {
      const { field, ...attrs } = extract_key_operator(key);
      // Primitive value → compare = "="
      result[index++] = {
        key: field,
        value,
        compare: "=",
        ...attrs,
      };
    }
  }

  return result;
}

// function object_to_compare_array(obj) {
//   const result = [];
//
//   for (const key in obj) {
//     const value = obj[key];
//
//     // ✅ Handle logical relations ('and' / 'or')
//     if (['and', 'or'].includes(key)) {
//       const nested = object_to_compare_array(value);
//       // Insert relation marker at the start
//       nested.unshift({
//         key: 'relation',
//         value: key.toUpperCase() // AND / OR
//       });
//       result.push(nested);
//     }
//
//     else if (Array.isArray(value)) {
//       // If value is an array, use compare = "IN"
//       const { field, compare } = extract_key_operator(key);
//       result.push({
//         key: field,
//         value,
//         compare: "IN"
//       });
//     }
//
//     else if (isObject(value)) {
//       // If nested object, recurse and prefix keys if needed
//       const nested = object_to_compare_array(value);
//       nested.forEach(item => result.push(item));
//     }
//
//     else {
//       const { field, compare } = extract_key_operator(key);
//       // Primitive value → compare = "="
//       result.push({
//         key: field,
//         value,
//         compare,
//       });
//     }
//
//   }
//   return result;
// }
// End ChatGPT

function form_values_to_fetch_params(formValues) {
  const res = unwrap_label_value(formValues);
  return res;
}

function to_wordpress(params) {
  const res = object_to_compare_object(params);
  return res;
}

function are_params_equal(params1, params2) {
  const left = JSON.stringify(sanitise_params(params1));
  const right = JSON.stringify(sanitise_params(params2));
  return (left === right);
}

export {
  http_build_query,
  sanitise_params,
  to_wordpress,
  are_params_equal,
  form_values_to_fetch_params,
};
